import facebook_sdk_loader from "~/mixins/third_party/loader/facebook"
import * as Facebook from "fb-sdk-wrapper"

export default {
  mixins: [facebook_sdk_loader],
  data() {
    return {
      fbData: null,
      fbUserData: null,
    }
  },
  created() {
    this.fbLoad()
  },
  methods: {
    fbCheckIfLogged() {
      return new Promise((resolve, reject) => {
        Facebook?.getLoginStatus()
          .then((response) => {
            resolve(response)
          })
          .catch(() => {
            reject(new Error(this.$t("errors.facebook.sdk_load_fail")))
          })
      })
    },
    fbAuth() {
      return new Promise((resolve, reject) => {
        const vm = this

        Facebook?.login({ scope: "email" }).then((resp) => {
          if (resp.status === "connected") {
            vm.$set(vm, "fbData", resp)
            resolve(resp)
          } else reject(new Error(vm.$t("errors.facebook.auth_fail")))
        })
      })
    },
    fbLogin() {
      return new Promise((resolve, reject) => {
        const vm = this

        vm.fbCheckIfLogged().then((resp) => {
          if (resp.status === "connected") {
            vm.$set(vm, "fbData", resp)
            resolve(resp)
          } else {
            Facebook?.login(
              async (resp) => {
                if (resp.status === "connected") resolve(await vm.fbLogin())
                else reject(new Error(vm.$t("errors.facebook.login_fail")))
              },
              { scope: "email" }
            )
          }
        })
      })
    },
    fbLogout() {
      return new Promise((resolve, reject) => {
        const vm = this

        if (this.fbIsLoggedIn && this.fbHasData) {
          Facebook?.logout()
            .then((resp) => {
              resolve(resp)
            })
            .catch(() => {
              reject(new Error(vm.$t("errors.facebook.logout_fail")))
            })
        } else {
          this.fbFetchData().then(() => {
            vm.fbLogout().finally(() => resolve())
          })
        }
      })
    },
    fbFetchData() {
      return new Promise((resolve, reject) => {
        const vm = this

        if (!this.fbIsLoggedIn) {
          this.fbLogin().then(async () => {
            resolve(await vm.fbFetchData())
          })
        } else {
          Facebook?.api("/" + this.fbData.authResponse.userID, {
            fields: "email,address,last_name,name,short_name,location",
          })
            .then((resp) => {
              this.fbUserData = resp
              resolve(resp)
            })
            .catch(() => {
              reject(new Error(vm.$t("errors.facebook.data_fetch_fail")))
            })
        }
      })
    },
    fbParseLocation() {
      try {
        if (this.fbUserData) {
          var arr = this.fbUserData.location.name.split(",")
          var country = arr[arr.length - 1].replace(/ /gi, "")

          return country
        } else return ""
      } catch (e) {
        return ""
      }
    },
  },
  computed: {
    fbHasData() {
      return (
        this.fbIsLoggedIn &&
        typeof this.fbData.authResponse.userID !== "undefined"
      )
    },
    fbIsLoggedIn() {
      if (
        this.fbData &&
        this.fbData.authResponse &&
        this.fbData.authResponse.accessToken
      )
        return true
      else return false
    },
  },
}
